import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareAbroadMarketPopularBlockData from '../../../Models/Content/SelfCareAbroadMarketPopularBlockData';
import SelfCareAbroadMarketPopularMain from "./SelfCareAbroadMarketPopularMain"

export default class SelfCareAbroadMarketPopularBlock extends EpiComponent<SelfCareAbroadMarketPopularBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return (
      <SelfCareAbroadMarketPopularMain context={this.getContext()} iContent={this.props.data} />
    );
  }
}
